import Lenis from '@studio-freight/lenis';

export const initLenis = () => {
  const lenis = new Lenis({ smooth: true });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
};
